/**
 * Product Vue Component
 * ------------------------------------------------------------------------------
 * Main template in sections/product.liquid
 * Can be reused for other instances of a product
 */

import axios from 'axios';
import Cookies from 'js-cookie';
import Slick from 'vue-slick';
import { getUrlWithVariant } from '@shopify/theme-product-form'; 

import ImageZoom from './image-zoom.vue';
import ReadMore from './read-more.vue';
import Accordion from './accordion.vue';
import Collapsible from './collapsible.vue';
import ButtonSpinner from './button-spinner.vue';


import { app } from '../app.js';
import { removeParameterFromUrl } from '../utils/helpers.js';

export default {
    components: {
        Slick,
        ImageZoom,
        ReadMore,
        Accordion,
        Collapsible,
        ButtonSpinner
    },
    props: {
        productHandle: {
            type: String,
            required: true
        },
        isProductPage: {
            type: Boolean,
            default: false
        },
        selectedOrFirstAvailableVariant: {
            type: Object
        }
    },

    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            isAdded: false,
            product: null,
            options: [],
            recentlyViewed: [],
            currentVariant: null,
            quantity: 1,
            isSizeGuideModalOpened: false,
            isAddedToWishlist: false,
            mainSlickOptions: {
                slidesToShow: 2,
                focusOnSelect: true,
                dots: true,
                arrows : false,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }]
            }
        }
    },
    computed: {
        fileUrl() {
            return app.fileUrl;
        },
        isSale () {
            return this.currentVariant && this.currentVariant.compare_at_price > this.currentVariant.price;
        },
        discountPercentage () {
            return Math.round((this.currentVariant.compare_at_price - this.currentVariant.price) / (this.currentVariant.compare_at_price) * 100);
        }

    },
    
    beforeCreate() {
        const recentlyViewedCookie = Cookies.get('recently_viewed')

        if(!recentlyViewedCookie) {
            Cookies.set('recently_viewed', JSON.stringify([]), { expires: 7 })
        }
    },

    created() {
        this.isLoading = true;

        axios.get(`/products/${this.productHandle}.js`).then((response) => {
            this.product = response.data;
            this.currentVariant = this.product.variants[0];
            
            // if the URL has ?variant=[variant.id], select that variant
            let queryStringValues = new URLSearchParams(window.location.search);
            if (queryStringValues.has('variant')) {
                let variantFromQueryString = this.product.variants.find((variant) => {
                    return variant.id == queryStringValues.get('variant');
                });
                if (variantFromQueryString) this.currentVariant = variantFromQueryString;
            
            } else if (this.product.variants.length == 1) {
                this.currentVariant = this.product.variants[0];
            }else{
                this.currentVariant = this.selectedOrFirstAvailableVariant;
            }

            if (this.currentVariant) {
                for (let i = 1; i <= this.product.options.length; i++) {
                    this.options.push(this.currentVariant['option' + i]);
                }

         
                this.updateVariant();
             
                
            } else {
                for (let i = 1; i <= this.product.options.length; i++) {
                    this.options.push('');
                }
            }

            this.populateRecentlyViewed()

        }).catch((error) => {
            console.log(error);

        }).finally(() => {
            this.isLoading = false;
        });
    },

    methods: {
    
        checkWishlist() {
            // setTimeout(() => {
            //     checkIwish($('.product-detail'), this.currentVariant.id.toString());
            // }, 1000);

            let userWishList = localStorage.getItem('iWishlistmain');
            
            if(userWishList) {
                Object.entries(JSON.parse(userWishList)).map(id => {
                    if(id[0] == this.product.id) {
                        this.isAddedToWishlist = id[1].find(variantId => variantId == this.currentVariant.id) ? true : false
                    }
                })
            }
            // console.log('yo');
        },

        handleAddToWishlist(event) {
            if(this.isAddedToWishlist) {
                iwish_remove($(event.target), this.currentVariant.id.toString())
                $(event.target).removeClass('iwishAdded')
                this.isAddedToWishlist = false
                
            } else {
                iwish_add($(event.target), this.currentVariant.id.toString())
                this.isAddedToWishlist = true
                $(event.target).addClass('iwishAdded')
            }
        },

        updateVariant(selectedVariant) {
            let variant = null;

            if (selectedVariant) {
                variant = selectedVariant;
            }else{
                variant = this._findVariant();
            }

            this._setVariant(variant);
            this.checkWishlist();

        },

        populateRecentlyViewed() {
            const productsCookie = Cookies.get('recently_viewed')
            let recentlyViewedProducts = JSON.parse(productsCookie)
            if(!recentlyViewedProducts.includes(this.product.id)) {
                recentlyViewedProducts.push(this.product.id)
            }
            Cookies.set('recently_viewed', JSON.stringify(recentlyViewedProducts), { expires: 7 })
        },

        handleAddToCart() {
            if (this.currentVariant) {
                this.isSubmitting = true;

                app.addToCart(this.currentVariant.id, this.quantity).then((response) => {
                    this.isSubmitting = false;
                    this.isAdded = true;
                    setTimeout(() => {
                        this.isAdded = false;
                    },2000);
                  
                    

                }).catch((error) => {
                    console.log('error', error);
                    this.isSubmitting = false;
                    alert('Cannot reach the server at this time, please try again later.');
                });
            }
        },

        // When product has multiple options, we need to find the associated variant based on those options
        _findVariant() {
            for (let i = 0; i < this.product.variants.length; i++) {
                if (this.product.variants[i].option1 && this.product.variants[i].option1 != this.options[0]) continue;
                if (this.product.variants[i].option2 && this.product.variants[i].option2 != this.options[1]) continue;
                if (this.product.variants[i].option3 && this.product.variants[i].option3 != this.options[2]) continue;

                return this.product.variants[i];
            }

            return null;
        },

        _setVariant(variant) {
            if (!variant) {
                this.currentVariant = null;
                removeParameterFromUrl('variant');
                return;
            }

            this.currentVariant = variant;
            
            if (this.isProductPage) {
                if (variant.featured_image && this.product.images.length > 1)
                    this.$refs.main.goTo(variant.featured_image.position - 1);

                let url = getUrlWithVariant(window.location.href, variant.id);
                window.history.replaceState({path: url}, '', url);
            }
        },
        handleModalOpen() {
            this.isSizeGuideModalOpened = !this.isSizeGuideModalOpened
        },

        handleModalClose() {
            this.isSizeGuideModalOpened = false
        }
    }


};